import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/common/PageLoader";

export function ProtectedRoute({ children, permission }) {
  const { user, can } = useAuth();
  const location = useLocation();
  if (user === null) return <PageLoader />;
  if (user === false) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (permission && !can(permission)) return <Navigate to="/" replace />;
  return children;
}
